const APP_INFO = 'appInfo'

function _sortFunc (a, b) {
  return a.sort - b.sort
}

export function listToTree (srcList, destList, sortFunc = _sortFunc) {
  if (!destList) {
    destList = []
  } else {
    destList.splice(0, destList.length)
  }
  if (!srcList) return destList
  const nodeData = {}
  srcList.forEach(item => {
    if (item.name) {
      item.label = item.name
      item.value = item.id
    }
    item.children = []
    nodeData[item.id] = item
  })
  srcList.forEach(item => {
    if (item.parentId) {
      const parent = nodeData[item.parentId]
      if (parent) {
        parent.children.push(item)
        parent.children.sort(sortFunc)
        return
      }
    }
    destList.push(item)
  })
  destList.sort(sortFunc)
  return destList
}

export function formatTime (timestamp, format = 'yyyy-MM-dd HH:mm') {
  const formatNum = num => {
    return String(num).padStart(2, '0')
  }
  const date = new Date(timestamp)
  return format.replace(/yyyy/g, date.getFullYear())
    .replace(/MM/g, formatNum(date.getMonth() + 1))
    .replace(/dd/g, formatNum(date.getDate()))
    .replace(/HH/g, formatNum(date.getHours()))
    .replace(/mm/g, formatNum(date.getMinutes()))
    .replace(/ss/g, formatNum(date.getSeconds()))
    .replace(/SSS/g, formatNum(date.getMilliseconds()))
}

export function treeToList (tree, list = [], level = 1) {
  if (tree) {
    tree.forEach(element => {
      list.push(element)
      element.level = level
      element.children && treeToList(element.children, list, level + 1)
      delete element.children
    })
  }
  return list
}

export function IsPC () {
  var userAgentInfo = navigator.userAgent
  var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
  var flag = true
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  return flag
}

export function getLangDate () {
  var dateObj = new Date() // 表示当前系统时间的Date对象
  var year = dateObj.getFullYear() // 当前系统时间的完整年份值
  var month = dateObj.getMonth() + 1 // 当前系统时间的月份值
  var date = dateObj.getDate() // 当前系统时间的月份中的日
  var day = dateObj.getDay() // 当前系统时间中的星期值
  var weeks = [
    '星期日',
    '星期一',
    '星期二',
    '星期三',
    '星期四',
    '星期五',
    '星期六'
  ]
  var week = weeks[day] // 根据星期值，从数组中获取对应的星期字符串
  var hour = dateObj.getHours() // 当前系统时间的小时值
  var minute = dateObj.getMinutes() // 当前系统时间的分钟值
  var second = dateObj.getSeconds() // 当前系统时间的秒钟值
  // 如果月、日、小时、分、秒的值小于10，在前面补0
  if (month < 10) {
    month = '0' + month
  }
  if (date < 10) {
    date = '0' + date
  }
  if (hour < 10) {
    hour = '0' + hour
  }
  if (minute < 10) {
    minute = '0' + minute
  }
  if (second < 10) {
    second = '0' + second
  }
  let newDate = [
    hour +
    ':' +
    minute,
    year +
    '/' +
    month +
    '/' +
    date + '&nbsp;&nbsp;' +
    week
  ]

  return newDate
}

export function setAppId (appId) {
  localStorage.setItem('appId', appId)
}

export function getAppId () {
  return localStorage.getItem('appId')
}

export function setAppInfo (appInfo) {
  localStorage.setItem(APP_INFO, JSON.stringify(appInfo))
}

export function getAppInfo () {
  return localStorage.getItem(APP_INFO)
}



// WEBPACK FOOTER //
// ./src/libs/tool.js